import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled from 'styled-components';
import { useTaktId, createStormTaktId, TextButton, Button } from '@amzn/storm-ui';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';

const FlexContainer = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-yjg4gu-0"
})(["border-top:", ";display:flex;flex-direction:row;justify-content:flex-end;padding-inline:", ";padding-block:", ";gap:", ";"], ({
  theme
}) => theme.border.subtle.default, ({
  theme
}) => theme.spacing.base.default, ({
  theme
}) => theme.spacing.small.default, ({
  theme
}) => theme.spacing.small.default);
const CountrySelectorFooter = ({
  id,
  countries,
  onClose,
  onSelect,
  applyButtonText,
  taktId,
  taktValue
}) => {
  const {
    formatMessage
  } = useIntl();
  const {
    getDataTaktAttributes
  } = useTaktId({
    taktId,
    fallbackId: createStormTaktId('country-selector-footer')
  });
  return /*#__PURE__*/React__default.createElement(FlexContainer, null, countries.length > 1 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(TextButton, _extends({}, getDataTaktAttributes({
    taktValue,
    taktIdSuffix: 'cancel-button'
  }), {
    id: `${id}-cancel-button`,
    onClick: onClose
  }), formatMessage({
    id: 'cancel-button-label'
  })), /*#__PURE__*/React__default.createElement(Button, _extends({}, getDataTaktAttributes({
    taktValue,
    taktIdSuffix: 'apply-button'
  }), {
    id: `${id}-change-country-button`,
    onClick: onSelect,
    variant: "primary"
  }), applyButtonText || formatMessage({
    id: 'apply-button-label'
  }))), countries.length === 1 && /*#__PURE__*/React__default.createElement(Button, _extends({}, getDataTaktAttributes({
    taktValue,
    taktIdSuffix: 'done-button'
  }), {
    id: `${id}-done-button`,
    onClick: onClose
  }), formatMessage({
    id: 'done-button-label'
  })));
};

export { CountrySelectorFooter as C };
//# sourceMappingURL=CountrySelectorFooter-Cayernxv.js.map
